import { createContext } from 'react'

export const RequestProfileTabEmailsSummaryExpandContext = createContext()
